<template>
  <b-modal title="요금 상세 정보" v-model="visible" scrollable centered header-class="bg-modal-header">

    <template #modal-header>
      <div class="fw-bold">{{ $_app.code.busiId[chargePriceResult[0].com_code] }} 충전 요금 안내</div>
    </template>

    <div style="max-height: 80vh">
      <div v-if="!$_utils.isEmpty(chargePriceResult)">
        <!--        <div class="mb-3 py-2 rounded bg-primary text-white text-center">-->
        <!--          {{ $_app.code.busiId[chargePriceResult[0].com_code] }} 충전 요금 안내-->
        <!--        </div>-->

        <template>
          <span class="d-flex justify-content-end mini-title mb-2">{{ chargeFeeInfo.priceChangeDate }} 기준 </span>
          <div v-for="(priceInfo,i) in chargePriceResult" :key="`priceInfo${i}`">
            <div class="detail-info-border mb-2">
              <!--  Season Price Start  -->
              <div v-if="!checkSameSeasonPrice(priceInfo.sf_ac_price, priceInfo.sm_ac_price, priceInfo.wt_ac_price)" class="modal-content-group">
                <div class="row justify-content-between">
                  <span class="col">{{ priceInfo.basic_price > 0 ? `기본요금 ${ $_utils.comma(priceInfo.basic_price) }원` : '' }}</span>
                  <div class ="col d-flex justify-content-end mini-title">
                    <span class="mx-3"> {{ !$_utils.isEmpty(priceInfo.capacity_power) ? priceInfo.capacity_power : '-' }}kW </span>
                    <span> {{ !$_utils.isEmpty(priceInfo.price_type) ? $_app.code.priceType[priceInfo.price_type] : '' }} </span>
                  </div>
                </div>
                <div class="charge-fee-modal-table">
                  <div class="type-use-table">
                    <b-table class="datatables text-nowrap"
                             outlined
                             :fields="seasonFields"
                             :items="createSeasonPricesItems(i)">
                    </b-table>
                  </div>
                </div>
              </div>

              <div v-else class="modal-content-group align-items-end">
                <div class="d-flex justify-content-between">
                  <div class="d-flex justify-content-end mini-title">
                    <span class="mx-3"> {{ !$_utils.isEmpty(priceInfo.capacity_power) ? priceInfo.capacity_power : '-' }}kW </span>
                    <span> {{ !$_utils.isEmpty(priceInfo.price_type) ? $_app.code.priceType[priceInfo.price_type] : '' }} </span>
                  </div>
                </div>
                <span class="w-75 border-bottom border-2 text-align-end"> {{ priceInfo.sf_ac_price.light }} 원</span>
              </div>
              <!--  Season Price End  -->

              <!--  AC Price Start  -->
              <div v-if="!isAllNonPositive(Object.values(priceInfo.etc_ac_price)) || !$_utils.isEmpty(Object.values(priceInfo.etc_ac_price))">
                <div v-if="priceInfo.etc_ac_price['3.5'] > 0 && !$_utils.isEmpty(priceInfo.etc_ac_price['3.5'])" class="modal-content-group align-items-end">
                  <div class="w-75 d-flex justify-content-end">
                    <span class="mini-title mx-3"> 3.5kW </span>
                    <span class="mini-title"> 완속 </span>
                  </div>
                  <span class="w-75 border-bottom border-2 text-align-end"> {{ priceInfo.etc_ac_price['3.5'] }} 원 </span>
                </div>
                <div v-if="priceInfo.etc_ac_price['11'] > 0 && !$_utils.isEmpty(priceInfo.etc_ac_price['11'])" class="modal-content-group align-items-end">
                  <div class="w-75 d-flex justify-content-end">
                    <span class="mini-title mx-3"> 11kW </span>
                    <span class="mini-title"> 완속 </span>
                  </div>
                  <span class="w-75 border-bottom border-2 text-align-end"> {{ priceInfo.etc_ac_price['11'] }} 원 </span>
                </div>
              </div>
              <!--  AC Price End  -->
            </div>
          </div>

          <hr class="border-dark my-4 w-50 mx-auto" style="border-top : 5px dotted"/>

          <!--  DC Price Start  -->
          <div v-if="chargePriceResult.length > 0">
            <div v-if="!$_utils.isEmpty(chargePriceResult[0].dc_price)  && !isAllNonPositive(Object.values(chargePriceResult[0].dc_price))" class="detail-info-border modal-content-group align-items-end">
              <div v-if="Object.values(chargePriceResult[0].dc_price).length === 4 && checkObjectValuesEquality(chargePriceResult[0].dc_price)" class="w-75 d-flex justify-content-between border-bottom border-2">
                <div class="d-flex flex-column align-items-end flex-grow-1 ml-3">
                  <span class="mini-title"> 급속 25~150kW </span>
                  <span class="text-align-end"> {{ Object.values(chargePriceResult[0].dc_price)[0] }} 원 </span>
                </div>
              </div>

              <div v-else class="w-75 d-flex justify-content-end align-content-between border-bottom border-2 ">
                <div v-if="chargePriceResult[0].dc_price['25~30'] > 0 && !$_utils.isEmpty(chargePriceResult[0].dc_price['25~30'])" class="d-flex flex-column align-items-end flex-grow-1 ml-3">
                  <span class="mini-title"> 급속 25~30kW </span>
                  <span class="text-align-end"> {{ chargePriceResult[0].dc_price['25~30'] }} 원 </span>
                </div>
                <div v-if="chargePriceResult[0].dc_price['50'] > 0 && !$_utils.isEmpty(chargePriceResult[0].dc_price['50'])" class="d-flex flex-column align-items-end flex-grow-1 ml-3">
                  <span class="mini-title"> 급속 50kW </span>
                  <span class="text-align-end"> {{ chargePriceResult[0].dc_price['50'] }} 원 </span>
                </div>
                <div v-if="chargePriceResult[0].dc_price['100'] > 0 && !$_utils.isEmpty(chargePriceResult[0].dc_price['100'])" class="d-flex flex-column align-items-end flex-grow-1 ml-3">
                  <span class="mini-title"> 급속 100kW </span>
                  <span class="text-align-end"> {{ chargePriceResult[0].dc_price['100'] }} 원 </span>
                </div>
                <div v-if="chargePriceResult[0].dc_price['150'] > 0 && !$_utils.isEmpty(chargePriceResult[0].dc_price['150'])" class="d-flex flex-column align-items-end flex-grow-1 ml-3">
                  <span class="mini-title"> 급속 150kW </span>
                  <span class="  text-align-end"> {{ chargePriceResult[0].dc_price['150'] }} 원 </span>
                </div>
              </div>
            </div>

            <div v-if="chargePriceResult[0].high_power_price > 0  &&!$_utils.isEmpty(chargePriceResult[0].high_power_price)" class="detail-info-border modal-content-group align-items-end">
              <div class="w-75 d-flex justify-content-between border-bottom border-2">
                <div class="d-flex flex-column align-items-end flex-grow-1 ml-3">
                  <span class="mini-title"> 초급속 350kW </span>
                  <span class="text-align-end"> {{ chargePriceResult[0].high_power_price }} 원 </span>
                </div>
              </div>
            </div>
          </div>
          <!--  DC Price End  -->

          <!--  Non Member Price Start  -->
          <div v-if="!$_utils.isEmpty(chargeFeeInfo.nonMemberPrice)" class="detail-info-border modal-content-group align-items-end">
            <span class="mini-title"> 비회원 </span>
            <span class="w-75 border-bottom border-2 text-align-end"> {{ typeof(chargeFeeInfo.nonMemberPrice) === "number" ? `${chargeFeeInfo.nonMemberPrice} 원` : chargeFeeInfo.nonMemberPrice }} </span>
          </div>
          <!--  Non Member Price End  -->

          <!--  Roaming Price Start  -->
          <div v-if="chargeFeeInfo.roamingPricesItems.length > 0" class="modal-content-group detail-info-border">
            <span class="text-right d-flex align-self-end mini-title">로밍</span>
            <div class="charge-fee-modal-table">
              <div class="type-use-table" style="word-break: keep-all">
                <b-table outlined
                         :fields="roamingFields"
                         :items="chargeFeeInfo.roamingPricesItems">
                </b-table>
              </div>
            </div>
          </div>
          <!--  Roaming Price End  -->

          <div class="modal-content-group">
            <div style="word-break: keep-all; padding-left: 10px;">충전 단가는 1kWh 기준 요금 입니다.
              <span v-if="!$_utils.isEmpty(chargePriceResult[0].price_desc)" style="word-break: keep-all; white-space:pre-wrap;"><br /><br />{{ chargePriceResult[0].price_desc }} </span>
            </div>
          </div>
          <div class="charge-fee-modal-table pb-1">
            <div class="modal-content-group type-use-table">
              <b-table outlined
                       :fields="descriptionFields"
                       :items="descriptionItems">
                <template v-slot:head(sp-sm-f)="data">
                  <div v-html="data.label"></div>
                </template>
                <template v-slot:cell(sp-sm-f)="data">
                  <div v-html="data.value"></div>
                </template>
                <template v-slot:cell(winter)="data">
                  <div v-html="data.value"></div>
                </template>
              </b-table>
            </div>
          </div>

        </template>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100">
        <b-button variant="secondary" class="float-end w-xs p-1" @click="visible=false">닫기</b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>

export default {
  name: "ChargeFeeInfoModal",
  props: {
    chargePriceResult: Array,
  },
  data() {
    return {
      visible: false,
      // JsonChargePriceResult:[],
      chargeFeeInfo: {
        priceChangeDate: null,
        nonMemberPrice: null,
        roamingPricesItems: [],
      },
      seasonFields: [' ','봄/가을', '여름', '겨울'],
      roamingFields:
        [{ key: 'roamingCo', label: '로밍 사업자', class: 'w-75' },
          { key: 'roamingPrice', label: '로밍요금', class: 'align-middle' }],
      descriptionFields:
        [{ key: 'type', label: '구분', class: 'align-middle'},
          { key: 'sp-sm-f', label: '봄/가을 (3~5월, 9~10월),<br/> 여름 (6~8월)', },
          { key: 'winter', label: '겨울 (11월~2월)', class: 'align-middle' }],
      descriptionItems:
        [{
          'type': '경부하',
          'sp-sm-f': '22:00 ~ 08:00',
          'winter': '22:00 ~ 08:00'
        },
          {
            'type': '중부하',
            'sp-sm-f': '08:00 ~ 11:00<br/>12:00 ~ 13:00<br/>18:00 ~ 22:00',
            'winter': '08:00 ~ 09:00<br/>12:00 ~ 16:00<br/>19:00 ~ 22:00'
          },
          {
            'type': '최대부하',
            'sp-sm-f': '11:00 ~ 12:00<br/>13:00 ~ 18:00',
            'winter': '09:00 ~ 12:00<br/>16:00 ~ 19:00'
          }],
    }
  },
  methods: {
    show() {
      const vm = this;

      vm.visible = true;
      // vm.JsonChargePriceResult = this.$_utils.parseResponseToJson(vm.chargePriceResult);
      vm.getPriceChangeDate();
      vm.getNonMemberPrice();
      vm.createRoamingPricesItems();
    },
    getPriceChangeDate() {
      const vm = this;

      const changedDateArr = vm.chargePriceResult.map(ele=> new Date(ele.price_change_date));
      vm.chargeFeeInfo.priceChangeDate = this.$moment(Math.max(...changedDateArr)).format('YYYY-MM-DD');
    },
    getNonMemberPrice() {
      const vm = this;

      const nonMemberPrices = vm.chargePriceResult.filter(ele => ele.non_member_price).map(ele => ele.non_member_price);
      const len = nonMemberPrices.length;

      if (len === 1) {
        vm.chargeFeeInfo.nonMemberPrice = nonMemberPrices[0] > 0 ? nonMemberPrices[0] : null
      } else if (len > 1){
        if(nonMemberPrices.every(price => price === nonMemberPrices[0])) {
          vm.chargeFeeInfo.nonMemberPrice = nonMemberPrices[0] > 0 ? nonMemberPrices[0] : null;
        } else vm.chargeFeeInfo.nonMemberPrice = '비회원 요금 확인 필요';
      } else vm.chargeFeeInfo.nonMemberPrice = null;
    },
    createRoamingPricesItems() {
      const vm = this;

      const roamingContainObjs = vm.chargePriceResult.filter(ele => ele.roaming_list_price);
      const len = roamingContainObjs.length;

      if (len === 1) {
        vm.chargeFeeInfo.roamingPricesItems = roamingContainObjs[0].roaming_list_price.list.map(priceObj => (
          {'roamingCo':Object.keys(priceObj)[0],'roamingPrice':`${Object.values(priceObj)[0]} 원`}
        ))
      } else if (len > 1){
        //같은 충전사업자에 로밍정보 중복 입력상태 (값 비교하거나 [0]정보 사용하거나)
        vm.chargeFeeInfo.roamingPricesItems = [{'roamingCo':'로밍요금 확인 필요','roamingPrice':'로밍요금 확인 필요'}];
      } else vm.chargeFeeInfo.roamingPricesItems = [];
    },
    createSeasonPricesItems(i) {
      const vm = this;

      const ele = vm.chargePriceResult[i];
      const prices = [ele.sf_ac_price.light, ele.sm_ac_price.light, ele.wt_ac_price.light, ele.sf_ac_price.heavy, ele.sm_ac_price.heavy, ele.wt_ac_price.heavy, ele.sf_ac_price.max, ele.sm_ac_price.max, ele.wt_ac_price.max]

      return [{ ' ': '경부하', '봄/가을': `${prices[0]} 원`, 여름:`${prices[1]} 원`, 겨울: `${prices[2]} 원` },
        { ' ': '중부하', '봄/가을': `${prices[3]} 원`, 여름: `${prices[4]} 원`, 겨울: `${prices[5]} 원` },
        { ' ' : '최대부하', '봄/가을': `${prices[6]} 원`, 여름: `${prices[7]} 원`, 겨울: `${prices[8]} 원` }]
    },

    isAllNonPositive(arr) {
      for (let i = 0, len = arr.length; i < len; i++) {
        if (arr[i] > 0) return false;
      }
      return true;
    },
    checkObjectValuesEquality(obj) {
      const values = Object.values(obj);

      return values.every(value => value === values[0]);
    },
    checkSameSeasonPrice(...objects) {
      const firstObjectValues = Object.values(objects[0]);

      for (let i = 1; i < objects.length; i++) {
        const currentObjectValues = Object.values(objects[i]);

        if (firstObjectValues.length !== currentObjectValues.length) {
          return false;
        }
        for (let j = 0; j < firstObjectValues.length; j++) {
          if (firstObjectValues[j] !== currentObjectValues[j]) {
            return false;
          }
        }
      }
      return true;
    }
  },
}
</script>